<template>
  <div style="min-height: 92vh" class="pa-4 pa-md-6 grey lighten-5">
    <!-- Encabezado Principal del Módulo -->
    <v-card class="pa-6 rounded-xl elevation-1 mb-6 border-light" color="white">
      <div class="d-flex flex-column flex-sm-row align-start align-sm-center justify-space-between gap-4">
        <div class="d-flex align-center">
          <v-avatar color="indigo lighten-5" size="48" class="mr-4">
            <v-icon color="indigo" size="28">mdi-currency-usd</v-icon>
          </v-avatar>
          <div>
            <h2 class="text-h5 font-weight-black indigo--text text--darken-4 mb-0">Reporte de Propinas</h2>
            <span class="text-caption grey--text text--darken-1 font-weight-medium">Consulta, desglose y análisis estadístico del personal</span>
          </div>
        </div>
        <div>
          <v-chip color="indigo" dark class="font-weight-bold" small>
            <v-icon left small>mdi-clock-outline</v-icon>
            {{ input_date.format('DD/MM/YYYY') }} - {{ input_date_final.format('DD/MM/YYYY') }}
          </v-chip>
        </div>
      </div>

      <v-divider class="my-5"></v-divider>

      <!-- Fila de Filtros -->
      <v-row class="align-center">
        <!-- Fila 1: Rango de Fechas y Turno -->
        <v-col cols="12" sm="4" md="3">
          <label class="text-caption font-weight-bold grey--text text--darken-2 d-block mb-1">Fecha inicial</label>
          <div style="border-bottom: 1.5px solid #1e3c72; padding: 2px 0;">
            <Datepicker
              :input-class="'v-input__control theme--light v-text-field dateinputClass '"
              @input="getAperturas()"
              @selected="selectDate"
              :value="input_date.format('MM/DD/YYYY')"
            ></Datepicker>
          </div>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <label class="text-caption font-weight-bold grey--text text--darken-2 d-block mb-1">Fecha final</label>
          <div style="border-bottom: 1.5px solid #1e3c72; padding: 2px 0;">
            <Datepicker
              :input-class="'v-input__control theme--light v-text-field dateinputClass '"
              @input="getAperturas()"
              @selected="selectDateFinal"
              :disabled-dates="disableDates"
              :value="input_date_final.format('MM/DD/YYYY')"
            ></Datepicker>
          </div>
        </v-col>
         <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            label="Departamentos"
            v-model="selectDep"
            item-text="Nombre"
            item-value="id"
            :items="departamentos"
            @change="getAperturas()"
            hide-details
            outlined
            dense
            background-color="grey lighten-5"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-autocomplete
            label="Turno"
            v-model="selectTurno"
            item-value="Turno"
            item-text="Desc"
            :items="turnosList"
            hide-details
            outlined
            dense
            background-color="grey lighten-5"
          >
            <template v-slot:append-outer>
              <v-btn @click="getAperturas()" small color="primary" class="mt-n1 font-weight-bold rounded-lg elevation-0" style="text-transform: none; height: 38px;">
                <v-icon left small>mdi-magnify</v-icon>
                Buscar turnos
              </v-btn>
            </template>
          </v-autocomplete>
        </v-col>

        <!-- Fila 2: Filtros de Negocio -->
       
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            label="Caja"
            @input="getAperturas()"
            v-model="selectCaja"
            item-value="id"
            item-text="Nomb"
            :items="data_cajas"
            hide-details
            outlined
            dense
            background-color="grey lighten-5"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            label="Meseros"
            v-model="selectedMesero"
            item-text="Nombre"
            item-value="id"
            :items="meserosComp"
            multiple
            @change="handleSelectChange"
            hide-details
            outlined
            dense
            background-color="grey lighten-5"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="cajero"
            :items="cajeros"
            item-value="id"
            item-text="Nomb"
            label="Cajero"
            hide-details
            outlined
            dense
            background-color="grey lighten-5"
          ></v-select>
        </v-col>

        <!-- Fila 3: Criterios adicionales y Búsqueda -->
        <v-col cols="12" sm="6" md="3">
          <v-text-field
            v-model="input_folio"
            label="Folio de Venta"
            hide-details
            outlined
            dense
            background-color="grey lighten-5"
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="3" md="3" class="d-flex align-center justify-center">
          <v-switch
            v-model="showDevs"
            label="Incluir devoluciones"
            color="red"
            hide-details
            class="mt-0"
          ></v-switch>
        </v-col>
        <v-col cols="6" sm="3" md="3" class="d-flex align-center justify-center">
          <v-switch
            v-model="showNoTips"
            label="Ventas sin propina"
            color="indigo"
            hide-details
            class="mt-0"
          ></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="d-flex align-center">
          <v-btn @click="getVentas()" color="indigo" dark block class="elevation-1 rounded-lg font-weight-bold" style="text-transform: none; height: 40px;">
            <v-icon left>mdi-magnify</v-icon>
            Filtrar y Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-card v-if="loadingData" class="pa-8 rounded-xl elevation-1 mb-6 text-center border-light" color="white">
      <v-progress-circular indeterminate color="indigo" size="64" width="6" class="mb-4"></v-progress-circular>
      <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Procesando información...</div>
      <div class="text-caption grey--text">Esto podría tomar unos segundos según el número de transacciones.</div>
    </v-card>

    <template v-else>

      <v-row class="mb-6">

        <v-col cols="12" md="6">
          <v-card class="pa-6 rounded-xl elevation-2 fill-height d-flex flex-column justify-center" >
            <div class="d-flex align-center mb-2">
              <v-icon color="white" class="mr-2" size="20">mdi-cash-multiple</v-icon>
              <div class="text-overline font-weight-black" style="letter-spacing: 0.12em; opacity: 0.85;">TOTAL DE PROPINAS ACUMULADAS</div>
            </div>
            <v-row align="center" no-gutters>
              <v-col cols="6" class="pr-2">
                <div class="text-h4 font-weight-black  line-height-tight">
                  {{ $pgsHelper.formatNumber(totalPropinas.pesos) }}
                </div>
                <div class="text-caption font-weight-bold " style="opacity: 0.8;">Pesos MXN</div>
              </v-col>
              <v-col cols="6" class="pl-3" style="border-left: 1.5px solid rgba(255, 255, 255, 0.25);">
                <div class="text-h4 font-weight-black  line-height-tight">
                  {{ $pgsHelper.formatNumber(comp_resumen_data.total_dolar) }}
                </div>
                <div class="text-caption font-weight-bold " style="opacity: 0.8;">Dólares USD</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" md="6" v-if="comp_resumen_data.totalVentas > 0">
          <v-card class="pa-6 rounded-xl elevation-2 fill-height d-flex flex-column justify-space-between" >
            <div class="d-flex align-center mb-2">
              <v-icon color="indigo lighten-4" class="mr-2" size="20">mdi-chart-pie-chart</v-icon>
              <div class="text-overline font-weight-black" style="letter-spacing: 0.12em; opacity: 0.85;">ANÁLISIS ESTADÍSTICO DE PROPINAS</div>
            </div>
            <v-row no-gutters align="center">
              <v-col cols="4" class="text-center">
                <div class="text-h5 font-weight-black green--text text--lighten-2">{{ comp_resumen_data.totalVentasConPropina }}</div>
                <div class="text-caption font-weight-medium " style="opacity: 0.8;">Con Propina ({{ comp_resumen_data.pctConPropina }}%)</div>
              </v-col>
              <v-col cols="4" class="text-center" style="border-left: 1.5px solid rgba(255, 255, 255, 0.15); border-right: 1.5px solid rgba(255, 255, 255, 0.15);">
                <div class="text-h5 font-weight-black red--text text--lighten-2">{{ comp_resumen_data.totalVentasSinPropina }}</div>
                <div class="text-caption font-weight-medium " style="opacity: 0.8;">Sin Propina ({{ comp_resumen_data.pctSinPropina }}%)</div>
              </v-col>
              <v-col cols="4" class="text-center pl-2">
                <div class="text-subtitle-2 font-weight-black  line-height-tight">
                  {{ $pgsHelper.formatNumber(comp_resumen_data.montoCuentasSinPropinaMXN) }} <span class="text-caption">MXN</span>
                </div>
                <div class="text-subtitle-2 font-weight-black  line-height-tight">
                  {{ $pgsHelper.formatNumber(comp_resumen_data.montoCuentasSinPropinaUSD) }} <span class="text-caption">USD</span>
                </div>
                <div class="text-caption font-weight-medium" style="opacity: 0.8;">Valor sin Propina</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- Resumen por Mesero (Tabla de Totales) -->
      <v-card class="rounded-xl overflow-hidden elevation-1 mb-6 border-light" color="white" outlined>
        <v-card-title class="grey lighten-4 py-3 px-4 font-weight-bold text-subtitle-1 indigo--text text--darken-4 d-flex align-center border-bottom-light">
          <v-icon color="indigo darken-2" class="mr-2" size="20">mdi-account-group-outline</v-icon>
          Resumen de Propinas por Mesero
        </v-card-title>
        
        <v-simple-table class="totals-table">
          <thead>
            <tr>
              <th class="text-left font-weight-bold grey--text text--darken-3 pl-6">Mesero</th>
              <th class="text-center font-weight-bold grey--text text--darken-3">Propina MXN</th>
              <th class="text-center font-weight-bold grey--text text--darken-3 pr-6">Propina USD</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="excel_totales.length === 0">
              <td colspan="3" class="text-center py-6 grey--text">No hay totales de meseros acumulados</td>
            </tr>
            <tr v-for="(row, index) in excel_totales" :key="index" class="hover-row">
              <td class="pl-6 font-weight-bold grey--text text--darken-3">
                <v-icon left small color="grey">mdi-account</v-icon>
                {{ row.Mesero }}
              </td>
              <td class="text-center font-weight-bold green--text text--darken-2">
                ${{ $pgsHelper.formatNumber(row.PropinaMXN) }}
              </td>
              <td class="text-center font-weight-bold indigo--text text--darken-2 pr-6">
                ${{ $pgsHelper.formatNumber(row.PropinaUSD) }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>

      <!-- Tabla Detallada de Transacciones -->
      <v-card class="rounded-xl overflow-hidden elevation-1 border-light" color="white" outlined>
        
        <!-- Cabecera de la Tabla y Botones de Excel -->
        <div class="px-5 py-4 grey lighten-4 d-flex flex-column flex-sm-row justify-space-between align-start align-sm-center gap-4 border-bottom-light">
          <div class="d-flex align-center">
            <v-icon color="indigo" class="mr-2" size="20">mdi-format-list-bulleted</v-icon>
            <span class="text-subtitle-1 font-weight-bold indigo--text text--darken-4">
              Transacciones Encontradas ({{ ventas_comp.length }})
            </span>
          </div>
          <div class="d-flex flex-wrap gap-2 width-sm-100">
            <v-btn color="success" outlined class="rounded-lg font-weight-bold text-none px-3" small @click="exportExcel(1)">
              <v-icon left small>mdi-file-excel-outline</v-icon>
              Exportar Totales
            </v-btn>
            <v-btn color="success" class="rounded-lg font-weight-bold text-none px-3 elevation-0" small @click="exportExcel(0)">
              <v-icon left small>mdi-microsoft-excel</v-icon>
              Exportar Detalle
            </v-btn>
          </div>
        </div>

        <!-- Tabla de Transacciones -->
        <v-simple-table class="detailed-table">
          <thead>
            <tr>
              <th class="text-left font-weight-bold pl-5">Folio</th>
              <th class="text-left font-weight-bold">Fecha / Hora</th>
              <th class="text-left font-weight-bold">Cliente</th>
              <th class="text-left font-weight-bold">Mesero</th>
              <th class="text-left font-weight-bold">Cajero</th>
              <th class="text-center font-weight-bold">Pago Propina</th>
              <th class="text-right font-weight-bold">Total Cuenta</th>
              <th class="text-right font-weight-bold">Propina</th>
              <th class="text-center font-weight-bold">Estatus</th>
              <th class="text-center font-weight-bold pr-5">Detalle</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="ventas_comp.length == 0">
              <td colspan="10" class="text-center py-8 grey--text font-weight-bold">
                <v-icon size="40" color="grey lighten-1" class="d-block mx-auto mb-2">mdi-database-alert-outline</v-icon>
                No se encontraron transacciones en este período.
              </td>
            </tr>
            <tr v-for="(res, index) in ventas_comp" :key="index" class="hover-row">
              <td class="pl-5">
                <span class="font-weight-black text-body-2 primary--text">{{ res.Folio }}</span>
              </td>
              <td class="text-caption">
                <div class="font-weight-bold">{{ res.FechaVenta }}</div>
                <div class="grey--text">{{ formatDate(res.FechaCreacion) }} hs</div>
              </td>
              <td class="text-truncate" style="max-width: 130px;">
                <span class="font-weight-medium grey--text text--darken-3">{{ res.Cliente.Nombre }}</span>
              </td>
              <td>
                <span class="text-caption font-weight-medium grey--text text--darken-2">
                  {{ res.Mesero ? res.Mesero.Nombre : "Sin Mesero" }}
                </span>
              </td>
              <td>
                <span class="text-caption font-weight-medium grey--text text--darken-2">
                  {{ $pgsHelper.getById(cajeros, "Id", res.Cajero) ? $pgsHelper.getById(cajeros, "Id", res.Cajero).Nomb : (res.Cajero || "Desconocido") }}
                </span>
              </td>
              <td class="text-center">
                <v-chip v-if="res.mpago" small color="teal lighten-5" text-color="teal darken-4" class="font-weight-bold text-caption">
                  {{ $pgsHelper.getById(getPDVPagosTipos, "id", res.mpago) ? $pgsHelper.getById(getPDVPagosTipos, "id", res.mpago).Nombre : res.mpago }}
                </v-chip>
                <v-chip v-else small color="grey lighten-3" text-color="grey darken-3" class="font-weight-medium text-caption">
                  Sin Propina
                </v-chip>
              </td>
              <td class="text-right font-weight-bold grey--text text--darken-3">
                ${{ $pgsHelper.formatNumber(res.Total) }}
                <v-chip x-small color="blue lighten-5" text-color="blue darken-4" class="font-weight-bold ml-1">{{ res.moneda }}</v-chip>
              </td>
              <td class="text-right">
                <span v-if="res.Cantidad > 0" class="green--text text--darken-2 font-weight-black">
                  +${{ $pgsHelper.formatNumber(res.Cantidad) }}
                </span>
                <span v-else class="grey--text text--lighten-1">
                  $0.00
                </span>
              </td>
              <td class="text-center">
                <v-chip small :color="res.Devos ? 'orange lighten-5' : 'green lighten-5'" :text-color="res.Devos ? 'orange darken-4' : 'green darken-4'" class="font-weight-bold">
                  {{ res.Devos ? "Devolución" : "Activo" }}
                </v-chip>
              </td>
              <td class="text-center pr-5">
                <v-btn small rounded outlined color="indigo" class="font-weight-bold text-none elevation-0" @click="showDetail(res)">
                  <v-icon left small>mdi-eye-outline</v-icon>
                  Ver
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </template>

    <!-- Modal de Detalles -->
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :selectedRes="selectedRes" />
    </modal>
  </div>
</template>

<script>
import "../../assets/css/sideBar.css";
import Datepicker from "vuejs-datepicker";
import Currency from "../../clases/Currencies.js";
import moment from "moment";
import modal from "../MainComponents/modal.vue";
import { mapGetters } from "vuex";
import Modificadores from "../../clases/Modificadores.js";
import resumenVenta from "../MainComponents/resumenVenta.vue";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
export default {
  name: "ReporteTransacciones",
  components: {
    Datepicker,
    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      selectTurno: "ALL",
      aperturas: [],
      meseros: [],
      showDevs: false,
      showNoTips: false,
      selectCaja: "",
      pagos: [],
      monedas: [],
      transaccion: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      cajero: "ALL",
      data_cajas: [],
      showModal: false,
      formKey: 0,
      data_ventas: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      selectDep: "ALL",
      cajeros: [{ id: "ALL", Nomb: "Todos" }],
      reservations: [],
      selectedMesero: ["ALL"],
    };
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    ...mapGetters(["getClientes", "getPDVPagosTipos", "getPDVMonedasLista"]),

    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });

      return pagos;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    meserosComp() {
      let dep = [
        {
          id: "ALL",
          Nombre: "TODOS",
        },
      ];
      let departamentos = this.meseros;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    ventas_comp() {
      const meserosMap = this.$pgsHelper.createIndex(this.meseros, 'id');
      this.data_ventas.forEach((venta) => {
        let mesero = "";
        for (const property in venta.Catalogo) {
          mesero = venta.Catalogo[property].ExtraParams?.AYB?.Mesero;
          if (venta.Catalogo[property].Modificadores) {
            venta.Catalogo[property].ModificadoresList =
              Modificadores.parseToListOption(
                venta.Catalogo[property].Modificadores
              );
            let totalModi = 0;
            venta.Catalogo[property].ModificadoresList.forEach((modi) => {
              totalModi += modi.pco.C;
            });
            venta.Catalogo[property].totalModi = totalModi;
          }
        }
        venta.Mesero = meserosMap.get(mesero) || false;
      });
      let data = this.data_ventas;
      let filData = [];
      data.forEach((ven) => {
        if (!this.selectedMesero.includes("ALL")) {
          if (ven.Mesero && this.selectedMesero.includes(ven.Mesero.id)) {
            filData.push(ven);
          }
        } else {
          filData.push(ven);
        }
      });
      let array = filData.sort(function (a, b) {
        const idA = a.Mesero ? a.Mesero.id : '';
        const idB = b.Mesero ? b.Mesero.id : '';
        if (idB > idA) return -1;
        if (idB < idA) return 1;
        return 0;
      });
      return array;
    },
    excel_data() {
      let dataExcel = [];
      this.ventas_comp.forEach((venta) => {
        dataExcel.push({
          Folio: venta.Folio,
          Fecha: venta.FechaVenta,
          Hora: this.formatDate(venta.FechaCreacion),
          Cliente: venta.Cliente.Nombre,
          Mesero: venta.Mesero ? venta.Mesero.Nombre : "Sin Mesero",
          Cajero: this.$pgsHelper.getById(this.cajeros, "Id", venta.Cajero)
            .Nomb,
          TipoPago: this.$pgsHelper.getById(
            this.getPDVPagosTipos,
            "id",
            venta.mpago
          ).Nombre,
          Total: Number(venta.Total),
          Propina: Number(venta.Cantidad),
          Moneda: venta.moneda,
          Estatus: venta.Devos ? "Devolucion" : "Activo",
        });
      });
      let data = dataExcel;
      /*let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });*/
      return data;
    },
    excel_totales() {
      let dataExcel = [];
      let totales = {};
      this.ventas_comp.forEach((venta) => {
        const meseroId = venta.Mesero ? venta.Mesero.id : 'no_mesero';
        const meseroNombre = venta.Mesero ? venta.Mesero.Nombre : "Sin Mesero";
        if (!totales[meseroId]) {
          let propinaMXN = 0;
          let propinaUSD = 0;
          if (venta.moneda == "MXN") {
            propinaMXN = venta.Cantidad;
          } else if (venta.moneda == "USD") {
            propinaUSD = venta.Cantidad;
          }
          totales[meseroId] = {
            Mesero: meseroNombre,
            PropinaMXN: propinaMXN,
            PropinaUSD: propinaUSD,
          };
        } else {
          if (venta.moneda == "MXN") {
            totales[meseroId].PropinaMXN += venta.Cantidad;
          } else if (venta.moneda == "USD") {
            totales[meseroId].PropinaUSD += venta.Cantidad;
          }
        }
      });
      let dataArray = Object.entries(totales);
      dataArray.forEach((item) => {
        dataExcel.push(item[1]);
      });
      let data = dataExcel;
      /*let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });*/
      return data;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    totalPropinas() {
      let pesos = 0;
      let dolar = 0;
      this.ventas_comp.forEach((venta) => {
        if (!venta.Devos) {
          const cantidad = Number(venta.Cantidad) || 0;
          if (venta.moneda === Currency.getCurrencyDefault()) {
            pesos += cantidad;
          } else {
            dolar += cantidad;
          }
        }
      });
      return {
        pesos: Number(pesos.toFixed(2)),
        dolar: Number(dolar.toFixed(2)),
      };
    },
    comp_resumen_data() {
      let total_products = 0;
      let total_golf_round = 0;
      let total_proshop = 0;
      let total = 0;
      let total_pagos = 0;
      let totalCambio = 0;
      let total_pesos = 0;
      let total_dolar = 0;
      
      let totalVentasConPropina = 0;
      let totalVentasSinPropina = 0;
      let montoCuentasConPropinaMXN = 0;
      let montoCuentasSinPropinaMXN = 0;
      let montoCuentasConPropinaUSD = 0;
      let montoCuentasSinPropinaUSD = 0;
      let salesCounted = new Set();

      this.ventas_comp.forEach((venta) => {
        let prod = Object.entries(venta.Catalogo);
        this.$pgsHelper.log(prod);
        prod.forEach((producto) => {
          if (producto[0] == "Golf_Round") {
            total_golf_round++;
          } else {
            total_proshop++;
          }
          total_products++;
        });
        if (!venta.Devos) {
          const cantidad = Number(venta.Cantidad) || 0;
          total_pagos = total_pagos + cantidad;
          total = total + parseInt(venta.Total || 0);
          totalCambio = totalCambio + (venta.Cambio ? Number(venta.Cambio.MXN || 0) : 0);
          if (venta.moneda === Currency.getCurrencyDefault()) {
            total_pesos = total_pesos + cantidad;
          } else {
            total_dolar = total_dolar + cantidad;
          }

          if (!salesCounted.has(venta.id)) {
            salesCounted.add(venta.id);
            if (cantidad === 0) {
              totalVentasSinPropina++;
              if (venta.moneda === 'USD') {
                montoCuentasSinPropinaUSD += Number(venta.Total || 0);
              } else {
                montoCuentasSinPropinaMXN += Number(venta.Total || 0);
              }
            } else {
              totalVentasConPropina++;
              if (venta.moneda === 'USD') {
                montoCuentasConPropinaUSD += Number(venta.Total || 0);
              } else {
                montoCuentasConPropinaMXN += Number(venta.Total || 0);
              }
            }
          }
        }
      });

      let totalVentas = totalVentasConPropina + totalVentasSinPropina;
      let pctConPropina = totalVentas > 0 ? ((totalVentasConPropina / totalVentas) * 100).toFixed(1) : 0;
      let pctSinPropina = totalVentas > 0 ? ((totalVentasSinPropina / totalVentas) * 100).toFixed(1) : 0;

      return {
        total_productos: total_products,
        total_rounds: total_golf_round,
        total_proshop: total_proshop,
        total_metodo_pagos: Number(parseFloat(total_pagos).toFixed(2)),
        totalCambio: totalCambio,
        total_pesos: Number(total_pesos.toFixed(2)),
        total_dolar: Number(total_dolar.toFixed(2)),
        total: total,
        
        totalVentas,
        totalVentasConPropina,
        totalVentasSinPropina,
        pctConPropina,
        pctSinPropina,
        montoCuentasConPropinaMXN: Number(montoCuentasConPropinaMXN.toFixed(2)),
        montoCuentasSinPropinaMXN: Number(montoCuentasSinPropinaMXN.toFixed(2)),
        montoCuentasConPropinaUSD: Number(montoCuentasConPropinaUSD.toFixed(2)),
        montoCuentasSinPropinaUSD: Number(montoCuentasSinPropinaUSD.toFixed(2)),
      };
    },
    comp_clients() {
      let clientes = [];
      this.getClientes.forEach((cli) => {
        clientes.push({ id: cli.id, text: cli.Apellidos + " " + cli.Nombres });
      });
      return clientes;
    },
    comp_filter() {
      let filter = [];

      this.pagos.forEach((pago) => {
        this.monedas.forEach((moneda) => {
          filter.push(pago + "_" + moneda);
        });
      });
      return filter;
    },
  },
  methods: {
    exportExcel(isTotales) {
      if(isTotales == 1) {
        GenericExcelExporter.generateExcelBuffer(this.excel_totales)
          .then(buffer => {
            const blob = new Blob([buffer], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = "Propina Totales.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch(error => console.error("Error exportando:", error));
        } else {
        GenericExcelExporter.generateExcelBuffer(this.excel_data)
          .then(buffer => {
            const blob = new Blob([buffer], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = "Reporte Propinas.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch(error => console.error("Error exportando:", error));

      }
   },
    handleSelectChange() {
      if (
        this.selectedMesero.includes("ALL") &&
        this.selectedMesero.some((item) => item !== "ALL")
      ) {
        // Si "ALL" está seleccionado junto con otros, elimina "ALL" y deja los otros
        let lengthSelected = this.selectedMesero.length;
        if (this.selectedMesero[lengthSelected - 1] == "ALL") {
          this.selectedMesero = ["ALL"];
        } else {
          this.selectedMesero = this.selectedMesero.filter(
            (item) => item !== "ALL"
          );
        }
      }
    },

    async getAperturas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where("Momento", ">=", startDate),
        firestore.where("Momento", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        //firestore.where("Caja", "==", this.$route.params.idInstalacion),
        firestore.where("Tipo", "==", "Apertura"),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(
          firestore.where("Departamentos", "array-contains", this.selectDep)
        );
      }
      if (this.selectCaja != "ALL" && this.selectCaja != "") {
        filter.push(firestore.where("Caja", "==", this.selectCaja));
      }
      const data = await firestore.queryBuilder("PDV_CierreApertura", filter);
      let aperturas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      const cajasMap = this.$pgsHelper.createIndex(this.data_cajas, 'id');
      const cajerosMap = this.$pgsHelper.createIndex(this.cajeros, 'Id');
      aperturas.forEach((apt) => {
        let fecha = new moment(apt.Momento, "YYYY-MM-DD_HH:mm:ss");
        let caja = cajasMap.get(apt.Caja) || {};
        let cajeroData = cajerosMap.get(apt.Cajero) || {};
        apt.CajaData = caja;
        apt.CajeroData = cajeroData;
        apt.CajeroName = cajeroData.Nomb;
        apt.Desc =
          "Turno Fecha " +
          fecha.format("DD-MM-YYYY") +
          " Hora: " +
          fecha.format("HH:mm") +
          " || " +
          caja.Nomb +
          " || " +
          cajeroData.Nomb +
          " || Turno: " +
          apt.Turno;
      });

      this.aperturas = aperturas;
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //console.log(new moment(d))
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("HH:mm");
    },
    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      if (num) {
        if (num != undefined) {
          return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
      }
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      this.loadingData = true;
      let turnos = [];
      if (this.selectTurno != "ALL") {
        turnos.push(this.selectTurno);
      } else {
        this.aperturas.forEach((de) => {
          turnos.push(de.Turno);
        });
      }
      let arrayFilter = this.pagos;
      if (this.transaccion) {
        arrayFilter = arrayFilter.map((pago) => {
          return pago + "-" + this.transaccion;
        });
      }

      let listVentas = [];
      let taskTurnos = turnos.map(async (id) => {
        const firestore = this.$store.getters.getFirebaseApp.firestore;
        let filter = [
          firestore.where("Turno", "==", id),

          firestore.where(
            "Tenant",
            "==",
            this.$store.getters.getFirebaseApp.tenant
          ),
        ];

        /*if (this.selectDep != "ALL" && this.selectDep != "") {
          filter.push(firestore.where("Departamento", "==", this.selectDep));
        }*/
        if (arrayFilter.length > 0) {
          filter.push(
            firestore.where("_PagoIdx", "array-contains-any", arrayFilter)
          );
        }
        if (this.input_folio != "") {
          filter.push(firestore.where("Folio", "==", this.input_folio));
        }

        if (this.selectClient != "") {
          filter.push(firestore.where("Cliente.Id", "==", this.selectClient));
        }

        if (this.input_cajero != "") {
          filter.push(firestore.where("Cajero", "==", this.input_cajero));
        }

        if (this.selectCaja != "") {
          filter.push(firestore.where("Caja", "==", this.selectCaja));
        }

        const data = await firestore.queryBuilder("PDV_Ventas", filter);
        let preData = [];
        preData = data.docs.map((doc) => {
          listVentas.push({ id: doc.ref.id, ...doc.data() });
          return { id: doc.ref.id, ...doc.data() };
        });
      });

      let data_ventas = [];
      await Promise.all(taskTurnos).then((turnos) => {
        data_ventas = listVentas;
      });

      let ventas = [];
      data_ventas.forEach((venta) => {
        let hasTips = false;
        if (venta.Props) {
          let props = Object.entries(venta.Props);
          let actualTips = props.filter(p => p[1] && p[1].Cantidad > 0);
          if (actualTips.length > 0) {
            hasTips = true;
            actualTips.forEach((pago) => {
              let pagos_moneda = pago[0].split("_");
              if (venta.Devos) {
                if (this.showDevs) {
                  ventas.push({
                    moneda: pagos_moneda[1] || 'MXN',
                    mpago: pagos_moneda[0] || '',
                    IdTran: pago[1].IdTran || '',
                    TipoPago: pago[0],
                    Cantidad: pago[1].Cantidad,
                    ...venta,
                  });
                }
              } else {
                ventas.push({
                  moneda: pagos_moneda[1] || 'MXN',
                  mpago: pagos_moneda[0] || '',
                  IdTran: pago[1].IdTran || '',
                  TipoPago: pago[0],
                  Cantidad: pago[1].Cantidad,
                  ...venta,
                });
              }
            });
          }
        }

        if (!hasTips) {
          if (this.showNoTips) {
            if (venta.Devos) {
              if (this.showDevs) {
                ventas.push({
                  moneda: venta.moneda || 'MXN',
                  mpago: '',
                  IdTran: '',
                  TipoPago: 'Sin Propina',
                  Cantidad: 0,
                  ...venta,
                });
              }
            } else {
              ventas.push({
                moneda: venta.moneda || 'MXN',
                mpago: '',
                IdTran: '',
                TipoPago: 'Sin Propina',
                Cantidad: 0,
                ...venta,
              });
            }
          }
        }
      });
      this.data_ventas = ventas;
      this.showEstad = true;
      this.loadingData = false;
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros"
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          let deptos = Object.entries(mesero.Deptos);
          let textDepto = "";
          deptos.forEach((depto) => {
            let testDepto = this.$pgsHelper.getById(
              this.departamentos,
              "Id",
              depto[0]
            );
            if (testDepto) {
              textDepto = textDepto + testDepto.Nombre + " ";
            }
          });
          mesero.DepartamentoText = textDepto;
        });
      }
    },
    async getCajeros() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajeros"
        );

      if (snapshot.exists()) {
        this.cajeros = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            // ajustar usuarios antiguos
            this.cajeros.push(toAdd);
          }
        });
      }
    },
  },
  async mounted() {
    await this.getAperturas();
    this.getCajas();
    this.getCajeros();
    this.getMeserosAB();
  },
  beforeCreate: function () {},
  beforeMount: function () {
    this.$emit("useNav", true);
  },
};
</script>

<style scoped>
.border-light {
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.border-bottom-light {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.gap-2 {
  gap: 8px;
}
.gap-4 {
  gap: 16px;
}
.line-height-tight {
  line-height: 1.2 !important;
}
.totals-table th, .detailed-table th {
  font-size: 0.85rem !important;
  color: #3f51b5 !important;
}
.totals-table td, .detailed-table td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  height: 52px !important;
}
.hover-row {
  transition: background-color 0.2s ease;
}
.hover-row:hover {
  background-color: #f5f7fa !important;
}
.dateinputClass {
  border: none !important;
  outline: none !important;
  width: 100%;
  font-weight: 500;
  color: #2c3e50;
  cursor: pointer;
}
@media (max-width: 600px) {
  .width-sm-100 {
    width: 100% !important;
    justify-content: space-between !important;
  }
}
</style>
